export default {
  data: function () {
    return {
      whenIsEmpty: "",
      vMoneyOptions: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
    };
  },
  methods: {
    totalPriceVatExcluded(
      orderItems,
      discount,
      packagingCost,
      transportCost,
      personCost,
      certificationCost,
      otherCost,
      currency
    ) {
      let temp1 = 0;
      try {
        temp1 =
          orderItems
            .map(
              (x) =>
                x.perPrice *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) -
          discount +
          parseFloat(packagingCost) +
          parseFloat(transportCost) +
          parseFloat(personCost) +
          parseFloat(certificationCost) +
          parseFloat(otherCost);
      } catch (error) {
        temp1 = 0;
      }

      if (temp1 >= 0) {
        if (currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
        else if (currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
        else temp1 = temp1;

        return temp1.toLocaleString() + " " + currency;
      } else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    },

    totalPrice(
      orderItems,
      discount,
      packagingCost,
      transportCost,
      personCost,
      certificationCost,
      otherCost,
      currency,
      vat
    ) {
      let temp1 = 0;
      try {
        temp1 =
          (orderItems
            .map(
              (x) =>
                x.perPrice *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) -
            parseFloat(discount) +
            parseFloat(packagingCost) +
            parseFloat(transportCost) +
            parseFloat(personCost) +
            parseFloat(certificationCost) +
            parseFloat(otherCost)) *
          (1 + vat / 100);
      } catch (error) {
        temp1 = 0;
      }

      if (temp1 >= 0) {
        if (currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
        else if (currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
        else temp1 = temp1;

        return temp1.toLocaleString() + " " + currency;
      } else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    },

    totalPriceNumeric(
      orderItems,
      discount,
      packagingCost,
      transportCost,
      personCost,
      certificationCost,
      otherCost,
      currency,
      vat
    ) {
      let temp1 = 0;
      try {
        temp1 =
          (orderItems
            .map(
              (x) =>
                x.perPrice *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) -
            parseFloat(discount) +
            parseFloat(packagingCost) +
            parseFloat(transportCost) +
            parseFloat(personCost) +
            parseFloat(certificationCost) +
            parseFloat(otherCost)) *
          (1 + vat / 100);
      } catch (error) {
        temp1 = 0;
      }

      if (temp1 >= 0) {
        if (currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
        else if (currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
        else temp1 = temp1;

        return temp1;
      } else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    },

    totalVat(
      orderItems,
      discount,
      packagingCost,
      transportCost,
      personCost,
      certificationCost,
      otherCost,
      currency,
      vat
    ) {
      let temp1 = 0;
      try {
        temp1 =
          (orderItems
            .map(
              (x) =>
                x.perPrice *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) -
            parseFloat(discount) +
            parseFloat(packagingCost) +
            parseFloat(transportCost) +
            parseFloat(personCost) +
            parseFloat(certificationCost) +
            parseFloat(otherCost)) *
          (vat / 100);
      } catch (error) {
        temp1 = 0;
      }

      if (temp1 >= 0) {
        if (currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
        else if (currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
        else temp1 = temp1;

        return temp1.toLocaleString() + " " + currency;
      } else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    },
  },
};
